import React, { useState } from "react";
import { Menu, X, Info } from "lucide-react";
import { BIZ, SLUG, NAV_PAGES } from "./psoData";
import ConceptCTAPill from "@/components/ConceptCTAPill";

export const NAVY = "#0B2545";
export const EMERALD = "#059669";
export const CREAM = "#F4F7F5";
export const SLATE = "#4B5566";

// Shared chrome for the 5-page PSO Accounting Group concept site. Plain JSX wrapper (not wired
// into React Router), matching the flat top-level-route convention used across this codebase.
export default function PsoLayout({ active, children }) {
  const [open, setOpen] = useState(false);
  const basePath = `/${SLUG}`;

  return (
    <div className="min-h-screen" style={{ background: CREAM, color: NAVY, fontFamily: "'Inter', sans-serif" }} data-testid="pso-concept-root">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');`}</style>

      <div data-testid="accounting-disclaimer" className="bg-black text-white text-center text-xs py-2.5 px-4">
        <span className="inline-flex items-center gap-2"><Info size={13} style={{ color: EMERALD }} />Concept website created by <a href="https://mysitecare.eu/ph" target="_blank" rel="noopener noreferrer" className="underline decoration-white/40 hover:decoration-white">MySiteCare</a> — not currently operated by or affiliated with {BIZ.name}.</span>
      </div>

      <header className="sticky top-0 z-40 shadow-sm" style={{ background: NAVY }}>
        <nav className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <a href={basePath} data-testid="pso-logo" className="text-white font-extrabold tracking-tight text-sm sm:text-base">PSO ACCOUNTING GROUP</a>
          <div className="hidden lg:flex items-center gap-7">
            {NAV_PAGES.map((p) => (
              <a
                key={p.key}
                href={`${basePath}${p.path}`}
                data-testid={`pso-nav-${p.key}`}
                className="text-sm font-medium transition-colors"
                style={{ color: active === p.key ? "#6EE7B7" : "rgba(255,255,255,0.7)" }}
              >
                {p.label}
              </a>
            ))}
          </div>
          <a href={`${basePath}/contact`} data-testid="pso-header-cta" className="hidden sm:inline-flex rounded-md px-5 py-2 text-sm font-semibold" style={{ background: EMERALD, color: "white" }}>Ask About Your Books</a>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="pso-menu-toggle" aria-label="Menu">{open ? <X size={22} /> : <Menu size={22} />}</button>
        </nav>
        {open && (
          <div className="lg:hidden px-5 pb-4 space-y-1" style={{ background: NAVY }}>
            {NAV_PAGES.map((p) => (
              <a key={p.key} href={`${basePath}${p.path}`} onClick={() => setOpen(false)} className="block py-2.5 font-medium" style={{ color: active === p.key ? "#6EE7B7" : "rgba(255,255,255,0.85)" }}>{p.label}</a>
            ))}
          </div>
        )}
      </header>

      {children}

      <footer className="py-8" style={{ background: NAVY }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/50">
          <p className="font-extrabold text-white">PSO ACCOUNTING GROUP</p>
          <p>This is an unsolicited concept website by MySiteCare. Not operated by or affiliated with {BIZ.name}. Confirm current details before visiting.</p>
        </div>
      </footer>

      <ConceptCTAPill slug={SLUG} />
    </div>
  );
}
